import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-time-customers-wo',
  templateUrl: './time-customers-wo.component.html',
  styleUrls: ['./time-customers-wo.component.css']
})
export class TimeCustomersWoComponent implements OnInit {
    custNo;

    public itemsListWorkingOrders: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadWorkingOrders() {
        if (!!this.custNo) {
            this.itemsListWorkingOrders = await this.datatask.Post(1291, {
                cust_name: 'ALL',
                cust_no: this.custNo,
                project_keyno: '0',
                ok: '0'
            });
        }
    }

    private async init() {
        this.loadWorkingOrders();
    }

    ngOnInit() {
        this.init();
    }
}
